// Web-side helpers for the Alerts module. The four alert_type values mirror
// the constants in api/src/lib/alerts.ts.

export const ALERT_TYPE_LABELS: Record<string, string> = {
  wo_overdue: "Overdue work order",
  lead_followup_overdue: "Overdue lead follow-up",
  inventory_low: "Low inventory",
  incident_stale: "Stale incident",
};

export function alertTypeLabel(t: string): string {
  return ALERT_TYPE_LABELS[t] ?? t;
}

// Map an alert's related entity to the SPA route a user should click through to.
// Returns null when the entity is unknown — the row stays non-clickable.
export function alertEntityHref(entityType: string, entityId: number): string | null {
  switch (entityType) {
    case "work_order":
      return `/work-orders/${entityId}`;
    case "lead":
      return `/leads/${entityId}`;
    case "inventory_item":
      return `/inventory/${entityId}`;
    case "incident":
      return `/incidents/${entityId}`;
    default:
      return null;
  }
}

// Soft-toned badge for the alert type, mirroring badge-* conventions elsewhere.
export function alertTypeBadge(t: string): string {
  if (t === "wo_overdue") return "alert";
  if (t === "incident_stale") return "alert";
  if (t === "inventory_low") return "warn";
  if (t === "lead_followup_overdue") return "warn";
  return "info";
}
